import type { Announcement, AnnouncementAck } from '@/modules/connect/use-cases'

export type AnnouncementAckDto = {
  userId: string
  name?: string | null
  ackedAt: string
}

export type AnnouncementDto = {
  id: string
  orgId: string
  orgType: 'club' | 'outfitter'
  authorId?: string | null
  authorName?: string | null
  title?: string | null
  body: string
  createdAt: string
  editedAt?: string | null
  ackCount?: number | null
  ackedByMe?: boolean | null
  acks?: AnnouncementAckDto[] | null
}

function toAck(dto: AnnouncementAckDto): AnnouncementAck {
  return {
    userId: dto.userId,
    name: dto.name || 'Member',
    ackedAt: dto.ackedAt,
  }
}

export function toAnnouncement(dto: AnnouncementDto): Announcement {
  return {
    id: dto.id,
    orgId: dto.orgId,
    orgType: dto.orgType,
    authorId: dto.authorId ?? undefined,
    authorName: dto.authorName || 'Former member',
    title: dto.title || null,
    body: dto.body,
    createdAt: dto.createdAt,
    editedAt: dto.editedAt ?? undefined,
    ackCount: dto.ackCount ?? 0,
    ackedByMe: dto.ackedByMe ?? false,
    ...(dto.acks ? { acks: dto.acks.map(toAck) } : {}),
  }
}
